import AuthStore from '@/modules/auth/services/Store'

export default function auth() {
    return AuthStore.isAuth()
}
